import { render, staticRenderFns } from "./InternalProjectsSelector.vue?vue&type=template&id=1e6a87fc&"
import script from "./InternalProjectsSelector.vue?vue&type=script&lang=js&"
export * from "./InternalProjectsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports